import api from "api";

const producerProfiles = {
    create: (payload) => {
        return api().post('/producer-profiles', payload);
    },

    me: () => {
        return api().get('/producer-profiles/me');
    },

    getBySlug: (slug) => {
        return api().get(`/producer-profiles/detail/${slug}`);
    },

    update: (slug, payload) => {
        return api().put(`/producer-profiles/${slug}`, payload);
    },

    delete: (slug) => {
        return api().delete(`/producer-profiles/${slug}`);
    },

    getEvents: (slug, status, page = 1, perPage = 15) => {
        return api().get(`/producer-profiles/producer/${slug}/events`, {
            params: { status, page, per_page: perPage }
        });
    },
};

export default producerProfiles;
